export class SportType {

  id;
  type;
  category: any[];

}
